var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.5,
    viewBox: "0 0 18 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-474.107 -361.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(471.107 364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,9a3,3,0,1,1,3-3A3,3,0,0,1,12,9Zm0-4.5A1.5,1.5,0,1,0,13.5,6,1.5,1.5,0,0,0,12,4.5Z",
    fill: "#ff385c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12A10.417,10.417,0,0,1,3.1,6.372a.748.748,0,0,1,0-.744A10.417,10.417,0,0,1,12,0a10.417,10.417,0,0,1,8.9,5.628.748.748,0,0,1,0,.744A10.417,10.417,0,0,1,12,12ZM4.623,6A8.84,8.84,0,0,0,12,10.5,8.84,8.84,0,0,0,19.377,6,8.84,8.84,0,0,0,12,1.5,8.84,8.84,0,0,0,4.623,6Z",
    fill: "#ff385c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.75a.747.747,0,0,1-.491-.183.75.75,0,0,1-.076-1.058l13-15a.75.75,0,0,1,1.058-.076A.75.75,0,0,1,13.567.491l-13,15A.748.748,0,0,1,0,15.75Z",
    transform: "translate(476.5 362.5)",
    fill: "#ff385c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye_closed.b19a94ffbb4ff5ad368f090db4852c0a.svg";
export { ForwardRef as ReactComponent };